export default {
  // Loading Page
  loading: {
    title: "Ihr Arbeitsbereich wird vorbereitet",
    message: "Bitte warten Sie, während wir Ihr Dashboard vorbereiten..."
  },
  // Sidebar Navigation
  sidebar: {
    dashboard: "Dashboard",
    recommendations: "Empfehlungen",
    organizationDesign: "Organisationsdesign",
    talentPool: "Talentpool",
    reports: "Berichte",
    notifications: "Benachrichtigungen",
    switchOrg: "Organisation wechseln"
  },
  // Talent Pool / Users Page
  talentPool: {
    relationshipAddedSuccessfully: "Beziehung erfolgreich hinzugefügt",
    relationshipRemovedSuccessfully: "Beziehung erfolgreich entfernt",
    relationshipSavedSuccessfully: "Beziehung erfolgreich gespeichert",
    profileCard: "Profilkarte",
    viewOptions: {
      plan: "Plan",
      hierarchy: "Hierarchie",
      network: "Netzwerk"
    },
    searchPlaceholder: "Benutzer suchen...",
    networkSearchPlaceholder: "Netzwerk suchen...",
    hierarchySearchPlaceholder: "Hierarchie suchen...",
    // KVDR Notifications
    kvdrNotifications: {
      create: "Erstellen",
      roleCreatedSuccessfully: "Rolle erfolgreich erstellt",
      delete: "Löschen",
      roleDeletedSuccessfully: "Rolle erfolgreich gelöscht",
      addProfile: "Profil hinzufügen",
      profileAddedSuccessfully: "Profil erfolgreich hinzugefügt",
      removeProfile: "Profil entfernen",
      profileRemovedSuccessfully: "Profil erfolgreich entfernt",
      roleUpdate: "Rollen-Update",
      updatedSuccessfully: "Erfolgreich aktualisiert",
      profileUpdate: "Profil-Update",
      profileUpdatedSuccessfully: "Profil erfolgreich aktualisiert"
    },
  },
  // Settings Help Page
  settingsHelp: {
    frequentlyAskedQuestions: "Häufig gestellte Fragen",
    question1: "Wie verwalte ich meine Organisationseinstellungen?",
    question2: "Wie kann ich neue Mitglieder zu meiner Organisation einladen?",
    question3: "Was sind die verschiedenen Benutzerrollen und Berechtigungen?",
    question4: "Wie passe ich das Branding meiner Organisation an?",
    helpText: "Dies ist ein Platzhalter-Hilfetext. Bitte wenden Sie sich an den Support für spezifische Hilfe bei Ihren Organisationseinstellungen und -konfigurationen."
  },
  // Create Organization
  createOrganization: {
    organizationName: "Organisationsname",
    organizationUsername: "Organisations-Benutzername",
    website: "Website",
    workEmail: "Arbeits-E-Mail",
    location: "Standort",
    organizationType: "Organisationstyp",
    primaryThemeColor: "Primäre Themenfarbe",
    secondaryThemeColor: "Sekundäre Themenfarbe",
    about: "Über uns",
    saveChanges: "Änderungen speichern",
    usernameExists: "Dieser Benutzername existiert bereits",
    usernameAvailable: "Dieser Benutzername ist verfügbar",
    organizationTypeOptions: {
      business: "Geschäft",
      academic: "Akademisch",
      recruiter: "Personalvermittler"
    },
    logo: {
      adjustTitle: "Organisationslogo anpassen",
      save: "Speichern",
      uploadButton: "Logo hochladen",
      incorrectFileType: "Falscher Dateityp",
      incorrectFileTypeText: "Bitte laden Sie einen unterstützten Bilddateityp hoch, z.B. jpg, png, etc.",
      fileSizeExceeded: "Bilddateigröße überschritten",
      fileSizeExceededText: "Die Größe des Profilbildes sollte weniger als 1MB betragen."
    }
  },

  // Main Organizations List
  main: {
    select: "Auswählen",
    acceptInvitation: "Einladung annehmen",
    noOrganizationFound: "Keine Organisation gefunden!",
    noOrganizationSubtext: "Erstellen Sie zuerst Ihre eigene Organisation.",
    createOrganization: "Organisation erstellen"
  },

  // Organization Dashboard
  organization: {
    welcomeBack: "Willkommen zurück! 👋",
    setupComplete: "Setup abgeschlossen!",
    setupProgress: "Setup: {step} von 4",
    copyLink: "Link kopieren",
    linkCopied: "Link kopiert",
    criticalRoles: "Kritische Rollen",
    talentPool: "Talentpool",
    integrations: "Integrationen",
    onboarding: "Onboarding",
    activeCandidates: "Aktive Kandidaten",
    connectedApps: "Verbundene Apps",
    pendingOnboards: "Ausstehende Onboards",
    kvdrReportsCenter: "KVDR-Berichtscenter",
    kvdrReportsDescription: "Tauchen Sie tief in Ihre wichtigsten visuellen Datenberichte ein und gewinnen Sie kritische Einblicke.",
    exploreReports: "Berichte erkunden >",
    talentPoolExplorer: "Talentpool-Explorer",
    talentPoolDescription: "Entdecken, analysieren und verwalten Sie Ihr Top-Talent mit umfassenden Einblicken.",
    exploreTalentPool: "Talentpool erkunden >",
    thisMonth: "diesen Monat",
    goToOnboarding: "Zum Onboarding"
  },

  // Reports
  reports: {
    title: "Berichte",
    nineCellMatrix: "9-Zellen-Matrix",
    xyPlot: "Streudiagramm",
    talentScoreCard: "Talent-Bewertungskarte",
    emptyReports: "Leere Berichte",
    createKVDRFirst: "Erstellen Sie zuerst einen KVDR und planen Sie, um Berichte anzuzeigen",
    // XY Plot specific
    xAxis: "X-Achse",
    yAxis: "Y-Achse",
    bubbleSize: "Blasengröße",
    loadingChart: "Diagramm wird geladen...",
    howToReadChart: "So lesen Sie dieses Diagramm",
    positioning: "Positionierung",
    horizontalPosition: "Horizontale Position zeigt",
    verticalPosition: "Vertikale Position zeigt",
    bubbleRepresentation: "Blasendarstellung",
    eachBubbleRepresents: "Jede Blase repräsentiert einen Mitarbeiter",
    sizeIndicates: "Größe zeigt",
    quadrants: "Quadranten",
    topLeft: "Oben-Links",
    topRight: "Oben-Rechts",
    bottomLeft: "Unten-Links",
    bottomRight: "Unten-Rechts",
    low: "Niedrig",
    high: "Hoch",
    interaction: "Interaktion",
    hoverOverBubble: "Fahren Sie über eine Blase",
    revealsDetailedMetrics: "Zeigt detaillierte Metriken für diesen Mitarbeiter",
    colorCoding: "Farbkodierung",
    differentColorsHelp: "Verschiedene Farben helfen, Mitarbeiter zu unterscheiden",
    // Nine Cell Matrix specific
    nineCellMatrixTitle: "Neun-Zellen-Matrix Mitarbeiterkategorisierung",
    methodologyDescription: "Standardisierte Methodik basierend auf Leistungsbewertung und Nachfolgebereitschaft",
    loading: "Lädt...",
    preparingMatrix: "Neun-Zellen-Matrix wird vorbereitet...",
    noDataAvailable: "Keine Daten verfügbar",
    employeeAssessmentRequired: "Mitarbeiterbewertungsdaten sind erforderlich, um die Neun-Zellen-Matrix anzuzeigen.",
    successionReadiness: "Nachfolgebereitschaft",
    performanceScore: "Leistungsbewertung",
    bargain: "SCHNÄPPCHEN",
    bind: "BINDEN",
    backup: "BACKUP",
    onTrack: "AUF KURS",
    boost: "BOOST",
    build: "AUFBAUEN",
    bootBarter: "BOOT/TAUSCH",
    employees: "Mitarbeiter",
    methodologyTitle: "Neun-Zellen-Matrix Methodik",
    methodologySubtitle: "Standardisierte Mitarbeiterkategorisierung basierend auf Leistungsbewertung und Nachfolgebereitschaft Berechnungen.",
    calculationMethod: "Berechnungsmethode",
    performanceScoreFormula: "Leistungsbewertung (P)",
    performanceScoreCalculation: "P = 0,6 × Leistung + 0,4 × Beurteilung",
    performanceScoreNote: "Rohwerte (-1 bis 1,5) werden auf 0-100 Skala normalisiert",
    successionReadinessFormula: "Nachfolgebereitschaft (R)",
    successionReadinessCalculation: "R = 0,5 × Nachfolge + 0,3 × Passung + 0,2 × Jahre Bewertung",
    successionReadinessNote: "Rohwerte (-1 bis 1,5) werden auf 0-100 Skala normalisiert",
    yearsScore: "Jahre Bewertung",
    yearsScoreCalculation: "Wenn Jahre ≥ 3: 100, sonst: (Jahre / 3) × 100",
    yearsScoreNote: "Derzeit wird Standard 2 Jahre verwendet (konfigurierbar)",
    cellCategories: "Zellenkategorien",
    backupDescription: "Hohe Leistung, Hohe Nachfolgebereitschaft",
    boostDescription: "Mittlere Leistung, Hohe Nachfolgebereitschaft",
    bindDescription: "Hohe/Mittlere Nachfolgebereitschaft, Niedrige/Mittlere Leistung",
    onTrackDescription: "Mittlere/Niedrige Leistung, Mittlere/Niedrige Nachfolgebereitschaft",
    buildDescription: "Mittlere Leistung, Niedrige Nachfolgebereitschaft",
    bargainDescription: "Niedrige Leistung, Hohe Nachfolgebereitschaft",
    bootBarterDescription: "Hohe Leistung, Niedrige Nachfolgebereitschaft",
    // Talent Score Card specific
    criteria: "Kriterien",
    talent: "TALENT",
    role: "ROLLE",
    remarks: "BEMERKUNGEN",
    weightage: "Gewichtung",
    good: "Gut (8-10)",
    average: "Durchschnittlich (5-7)",
    poor: "Schlecht (1-4)",
    notApplicable: "Nicht anwendbar"
  },

  // Talent Pool
  talentPool: {
    title: "Talentpool",
    reviewRequest: "Überprüfungsanfrage",
    // Main talent pool
    noPendingRequest: "Keine ausstehenden Anfragen gefunden",
    importFrom: "Importieren von",
    uploadExcel: "Excel hochladen",
    uploadResumes: "resumes hochladen",
    uploadResumesTooltip: "Resumes importieren (PDF)",
    orHRIS: "oder HRIS",
    pendingRequest: "Ausstehende Anfrage",
    allUsers: "Alle Benutzer",
    addNewEmployee: "Neue Mitarbeiterkarte hinzufügen",
    // Table headers
    name: "Name",
    email: "E-Mail",
    maxRole: "Max. Rolle",
    relationships: "Beziehungen",
    action: "Aktion",
    // User search
    searchUser: "Benutzer suchen",
    userNotFound: "Benutzer nicht gefunden.",
    // Relationship management
    member: "Mitglied",
    relationship: "Beziehung",
    addRelation: "Beziehung hinzufügen",
    removeRelationship: "Beziehung entfernen",
    // Add employee form
    firstName: "Vorname",
    lastName: "Nachname",
    roleTitle: "Rollentitel",
    save: "Speichern",
    // Profile card
    profileCard: "Profilkarte",
    // Import
    importFromExcel: "Von Excel importieren"
  },

  // Users
  users: {
    title: "Benutzer",
    manageUsers: "Benutzer verwalten",
    // User Recommendations
    talentRecommendations: "Talent-Empfehlungen",
    recommendationsDescription: "Basierend auf Ihrer KVDR-Bewertung finden Sie hier personalisierte Empfehlungen für Ihre Organisation",
    viewActivePlans: "Aktive Pläne anzeigen",
    // Recommendation Cards
    fitmentPlan: "Passungsplan",
    fitmentPlanDescription: "Onboarding von Personen in ihre Rollen.",
    fitmentPlanContent: "Onboarding von Personen in ihre Rollen. Zuordnung des richtigen Talents zu den richtigen Rollen mit Passungsindikatoren",
    developmentPlan: "Entwicklungsplan",
    developmentPlanDescription: "KI-gestütztes Lernen mit ALEX",
    developmentPlanContent: "Erstellung von Lernplänen mit ALEX Personalisierte Lernpfade zur Steigerung des Talentwerts durch Fähigkeiten.",
    successionPlanning: "Nachfolgeplanung",
    successionPlanningDescription: "Fördern und unterstützen Sie das Karrierewachstum",
    successionPlanningContent: "Fördern und unterstützen Sie das Karrierewachstum Coaching-Pläne für Fähigkeits- und Zeitbereitschaft für die nächste Rolle.",
    // Benefits Lists
    roadToRole: "Weg zu Ihrer Rolle (Reise)",
    skillProfiling: "Fähigkeitsprofilierung",
    learningCredits: "Lernkredite",
    marketRewards: "Marktbelohnungen",
    customLearningPaths: "Maßgeschneiderte Lernpfade",
    aiAssistedValidation: "KI-gestützte Validierung",
    progressTracking: "Fortschrittsverfolgung mit Erfahrungspunkten (XPs)",
    interactiveExercises: "Interaktive Übungen",
    appraisalIndicators: "360-Grad-Bewertungsindikatoren",
    goalSettingMentorship: "Zielsetzung & Mentoring",
    behaviouralCoaching: "Verhaltens-Coaching & Pläne",
    managedCareerGuidance: "Gemanagte Karriereberatung",
    // Action Buttons
    onboard: "Onboarding",
    activate: "Aktivieren",
    promote: "Fördern",
    // Progress Section
    talentCapabilitySnapshot: "Talent-Fähigkeits-Snapshot",
    lastUpdated: "Zuletzt aktualisiert: Heute",
    refresh: "Aktualisieren",
    // Score Labels
    industryLeader: "Branchenführer",
    highPerforming: "Hochleistung",
    competitive: "Wettbewerbsfähig",
    developing: "Entwickelnd",
    foundationBuilding: "Grundlagenaufbau",
    // Notifications
    alexActivated: "ALEX aktiviert",
    alexActivatedText: "Ihr KI-Lernassistent ist bereit zu helfen!",
    coachingRequestSent: "Coaching-Anfrage gesendet",
    coachingRequestSentText: "Ein Coach wird Sie in Kürze kontaktieren!",
    rewardsMarketplace: "Belohnungs-Marktplatz",
    rewardsMarketplaceText: "Verfügbare Belohnungen und Vorteile erkunden!"
  },

  // Integrations
  integrations: {
    title: "Integrationen",
    manageIntegrations: "Integrationen verwalten"
  },

  // Admins
  admins: {
    title: "Administratoren",
    manageAdmins: "Administratoren verwalten"
  }
};
